import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
 apiKey: "AIzaSyAOBU5C86pFTJyN7XiiKuhDHze0OPCRU8M",
  authDomain: "nexusforgefx.firebaseapp.com",
  projectId: "nexusforgefx",
  storageBucket: "nexusforgefx.firebasestorage.app",
  messagingSenderId: "118805841250",
  appId: "1:118805841250:web:632bcd79271254ae60983b"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const txtdb = getFirestore(app);

